/** Shape aligned with mobile `extractRagSolution` / API payload for future wiring. */
export type MockRagSolution = {
  answer: string;
  hints: string[];
  steps: string[];
};

export const DEFAULT_MOCK_RAG_SOLUTION: MockRagSolution = {
  answer:
    "Dividing 4 by 67 gives a proper fraction 4/67. As a decimal it is approximately 0.0597 (non-terminating).",
  hints: [
    "Remember that division can be expressed as a fraction where the dividend is the numerator and the divisor is the denominator.",
  ],
  steps: [
    "The problem asks us to divide 4 by 67.",
    "This can be written as the fraction 4/67.",
    "If a decimal is needed, perform long division or use a calculator for the repeating decimal expansion.",
  ],
};
